import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ spacing }) => ({
  row: {
    display: "flex",
    justifyContent: "space-between",
    "&:not(:last-child)": {
      marginBottom: spacing(2),
    },
  },
}));

export default useStyles;
